import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'

import * as styles from './GretaAIChatProjectName.module.css'

function GretaAIChatProjectName({ className = styles.name, name }) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  return (
    <FloatingTooltip content={name} disabled={!overflow}>
      <Text className={className} ref={setContentOverflowRef}>
        {name}
      </Text>
    </FloatingTooltip>
  )
}

export default GretaAIChatProjectName
